import {
    ColorSource,
    DEFAULT_BRAND_COLORS,
} from "../components/misc/custom-posts/CaptionedVideoMediaStep";
import { AutoVideoColorRef } from "../types/slideshow";

// MB-1366: shared converters between the persisted AutoVideoColorRef
// (BrandingSettings.autoVideoColor) and the UI's ColorSource. Used by the
// Listing Video Settings page AND the manual Create Slideshow dialog so the
// two stay in sync.

export const colorRefToSource = (
    ref?: AutoVideoColorRef
): ColorSource | undefined => {
    if (!ref) return undefined;
    return ref.source === "brokerage"
        ? { type: "brokerage", id: ref.brokerageId ?? "" }
        : { type: "custom", colors: ref.colors ?? DEFAULT_BRAND_COLORS };
};

export const colorSourceToRef = (source: ColorSource): AutoVideoColorRef =>
    source.type === "brokerage"
        ? { source: "brokerage", brokerageId: source.id }
        : { source: "custom", colors: source.colors };
